import hr from './hr';

export default{
    hr
}